import { ASSETS_LOCATIONS, getAssetsUrl } from '../../../../../../utilities/constants';

export const SUMMARY_IMAGES = {
  CART_LOGO: getAssetsUrl(ASSETS_LOCATIONS.SVG, 'Cart.svg'),
  CART_EMPTY_LOGO: getAssetsUrl(ASSETS_LOCATIONS.SVG, 'CartEmpty.svg'),
  CLOSE_MODAL_IMAGE: getAssetsUrl(ASSETS_LOCATIONS.SVG, 'close-icon.svg'),
  COUNTER_CONFETTI: getAssetsUrl(ASSETS_LOCATIONS.ANIMATION, 'Shopping_Cart_Confetti_Animation.json')
};
